import { HeaderPage } from 'components/header/HeaderPage';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { CustomTable } from 'components/table/style';
import { iconSort } from 'components/table/utlil';
import { Table, TextInput, closeModal, updateQueryStateTable } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { TABLE_KEY } from 'constants/table';

import { getInstitutionColumns } from '../core/columns';
import { useInstitutionsController } from '../core/controller/institutions';

export const InstitutionsPage = () => {
  const {
    institutionData,
    total,
    queryState,
    searchValue,
    onChangeSearchValue,
    goToAddPage,
    onClickAction,
    onSubmitDeleteInstitution,
    onClickRow,
  } = useInstitutionsController();

  const columns = getInstitutionColumns(onClickAction);

  if (!queryState) {
    return null;
  }

  return (
    <div className="full-width">
      <HeaderPage title="Institutions" onClick={goToAddPage} />
      <div>
        <TextInput
          containerStyle={{
            marginBottom: 16,
          }}
          value={searchValue.value}
          placeholder="Search by id, name, email"
          onChange={onChangeSearchValue}
          inputStyle={{
            backgroundColor: 'transparent',
            width: '30%',
          }}
          prefix={<SearchIcon />}
        />
        <CustomTable>
          <Table
            columns={columns}
            dataSource={institutionData}
            total={total.value}
            tableKey={TABLE_KEY.INSTITUTIONS}
            queryState={
              {
                ...queryState,
                orderBy:
                  queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                    ? 'name'
                    : queryState.orderBy,
                orderDirection:
                  queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                    ? 'ASC'
                    : queryState.orderDirection,
              }
            }
            updateQueryState={updateQueryStateTable}
            headerConfigs={{
              iconSort,
            }}
            onClickRow={onClickRow}
          />
        </CustomTable>
      </div>
      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_INSTITUTION}
        content={
          'All the stored data of this institution will be deleted. This action can not undo.'
        }
        header={'Delete institution'}
        onCancel={() => closeModal(MODAL_KEY.DELETE_INSTITUTION)}
        onSubmit={onSubmitDeleteInstitution}
      />
    </div>
  );
};
